import {Badge, Text, Wrap, WrapItem} from "@chakra-ui/react";

export const columnsDataManageRole = [
  {
    accessorKey: "userName",
    header: "Name User",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "userEmail",
    header: "Email User",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "roleName",
    header: "Name Role",
    cell: (info) => {
      const roles = String(info.getValue() || "").split(" | ").filter(Boolean);

      if (roles.length === 0) {
        return <Text color="secondaryGray.500">-</Text>;
      }

      return (
        <Wrap spacing={2} minW="180px">
          {roles.map((role, index) => (
            <WrapItem key={`${role}-${index}`}>
              <Badge colorScheme="blue" variant="subtle" borderRadius="full" px={2} py={1} textTransform="none">
                {role}
              </Badge>
            </WrapItem>
          ))}
        </Wrap>
      );
    },
  },
];
